export default "__VITE_ASSET__d865f80e__"